<template>
    <div>
        <div>
            <div class="d-flex flex-column question mb-2">
                <div class="text-muted mr-1 mb-1">Question:</div>
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="text-muted mr-1 mb-1">Options:</div>

        <b-list-group>
            <b-list-group-item
                v-for="(answer, index) in question.content.possible_answers"
                :key="index"
                :class="{'d-flex align-items-center': answer.value, 'd-none': !answer.value}"
            >
                <div class="text-capitalize text-muted mr-3">
                    {{answer.option}}
                </div>
                <div :class="{'text-success': answerSelected(answer.option)}" class="d-flex justify-content-center align-items-center">
                    <span v-if="answerSelected(answer.option)">
                        <font-awesome-icon :icon="['fad', 'check-square']" />
                    </span>
                    <template v-if="question.type == 'new_select_all_that_apply'"><span v-html="answer.value" class="v-html mx-3"></span><img :src="getImageSource(answer.value)" width="100" height="auto" class="m-2"></template>
                    <template v-if="question.type == 'select_all_that_apply'">{{' ' + answer.value}}</template>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<style lang="scss" scoped>
.option:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
}
.option + .option {
    margin-top: -1px;
}
.option:last-child {
    border-bottom-left-radius: .25rem;
    border-bottom-right-radius: .25rem;
}
</style>

<script>
export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        possible_answers_with_values () {
            let possible_answers = []

            _.forEach(this.question.content.possible_answers, possible_answer => {
                if (possible_answer.value) {
                    let answer = {value: '', option: possible_answer.option}
                    answer.value = possible_answer.value.replaceAll('<merlin-img', '<img')
                    answer.value = answer.value.replaceAll('</merlin-img', '</img')
                    possible_answers.push(answer)
                }
            })

            return possible_answers
        }
    },
    methods: {
        answerSelected (option) {
            if (_.includes(this.question.content.answers, option)) {
                return true
            } else {
                return false
            }
        },
        getImageSource(html) {
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = html

            const merlinImgElement = tempDiv.querySelector('merlin-img')
            const sbpImgElement = tempDiv.querySelector('sbp-img')

            if (merlinImgElement) {
                return merlinImgElement.getAttribute('src')
            } 
            else if (sbpImgElement) {
                return sbpImgElement.getAttribute('src')
            }
        }
    }
}
</script>
